const React = require("react");

function CakeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_2",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M17.7,0.95c0.04-0.03,0.1-0.03,0.13,0 c0.28,0.27,1.39,1.38,1.39,2.57c0,1.36-1.46,1.3-1.46,1.3c-0.61,0-1.44-0.39-1.44-1.26C16.32,2.73,16.99,1.56,17.7,0.95z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.76,
    x2: 17.76,
    y1: 4.82,
    y2: 9.6,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M11.99,0.95c0.04-0.03,0.1-0.03,0.13,0 c0.28,0.27,1.39,1.38,1.39,2.57c0,1.36-1.46,1.3-1.46,1.3c-0.61,0-1.44-0.39-1.44-1.26C10.61,2.73,11.28,1.56,11.99,0.95z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.06,
    x2: 12.06,
    y1: 4.82,
    y2: 9.6,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M6.15,0.95c0.04-0.03,0.1-0.03,0.13,0 c0.28,0.27,1.39,1.38,1.39,2.57c0,1.36-1.46,1.3-1.46,1.3c-0.61,0-1.44-0.39-1.44-1.26C4.78,2.73,5.45,1.56,6.15,0.95z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.22,
    x2: 6.22,
    y1: 4.82,
    y2: 9.6,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 0,
    y1: 23.08,
    y2: 23.08,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M21.69,23.08v-10.6c0-1.59-1.29-2.88-2.88-2.88 H5.19c-1.59,0-2.88,1.29-2.88,2.88v10.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M21.69,13.35c-1.61,0-1.91,2.08-3.31,2.08 c-1.49,0-2.01-1.97-3.23-1.97c-1.38,0-1.74,1.97-3.25,1.97c-1.39,0-1.84-1.95-3.29-1.95s-1.9,1.95-3.12,1.95 c-1.38,0-1.81-1.95-2.92-1.95H2.31"
  })));
}

module.exports = CakeIcon;